<template>
  <div class="mc-dashboard__widget-item">
    <div class="mc-dashboard__widget-header d-flex justify-content-between">
      <div>
        <h4 class="font-size-16 teal-400 mb-1">
          {{ $t('dashboard.chart.totalDistance') }}
        </h4>
        <p class="font-size-10 teal-400 mb-0">
          {{ monthsPeriod }}
        </p>
      </div>
    </div>
    <div class="mc-dashboard__widget-content">
      <b-skeleton-wrapper :loading="loading">
        <template #loading>
          <b-row>
            <b-col md="12">
              <b-skeleton width="100%" height="350px" />
            </b-col>
          </b-row>
        </template>
        <div v-if="!refresh" class="mc-chart">
          <LineChart
            :labels="totalChartData.distance.labels"
            :datasets="totalChartData.distance.datasets"
            :yLabel="$t('dashboard.chart.totalKm')"
          />
        </div>
      </b-skeleton-wrapper>
    </div>
  </div>
</template>

<script>
import LineChart from '@/components/Chart/Line'
import { Helper } from '@/mixin/helper'

export default {
  components: {
    LineChart,
  },

  mixins: [Helper],

  props: {
    loading: {
      type: Boolean,
    },
    tripsStatistics: {
      type: Object,
    },
    period: {},
  },

  data() {
    return {
      isLayoutEdit: false,
      refresh: false,
      months: [],
      localLoading: this.loading,
      drivingDistance: [],
      monthsPeriod: '',
    }
  },

  computed: {
    totalChartData() {
      return {
        distance: {
          labels: this.months,
          datasets: [
            {
              data: this.drivingDistance,
              label: this.$t('dashboard.chart.totalDistance') + ' (Km)',
              backgroundColor: '#cfdae9',
              borderColor: '#0d4491',
            },
          ],
        },
      }
    },
  },

  watch: {
    tripsStatistics: {
      handler(newVal) {
        if (newVal?.data?.length) {
          this.prepareChartData()
        }
      },
      immediate: true,
      deep: true,
    },
  },

  mounted() {
    if (this.tripsStatistics?.data?.length) {
      this.prepareChartData()
    }
  },

  methods: {
    prepareChartData() {
      this.months = this.tripsStatistics?.data.map((item) => this.localizeMonth(item.month))
      this.drivingDistance = this.tripsStatistics?.data.map((item) =>
        parseFloat(item.tripMileage.chosenValue).toFixed(2)
      )

      const months = this.tripsStatistics?.data.map(
        (item) => `${this.localizeMonth(item.month)} ${item.year}`
      )
      this.monthsPeriod = `${months[0]} - ${months[2]}`

      this.localLoading = false
    },
  },
}
</script>
